/**
 * @file index.js
 * @description Point d'entrée unique du package `@rx-schemas`.
 *              Ré-exporte tous les schémas Zod partagés front + back.
 *
 * @usage
 *   Backend Node.js:
 *     const { safeParseRxV1, safeParseMerchantPreview } = require('../../shared/rx-engine/schemas');
 *
 *   Frontend React (via CRACO alias @rx-schemas configuré en P0.6):
 *     import { safeParseRxV1, MerchantPreviewPayloadSchema } from '@rx-schemas';
 *
 * @spec RX_v1.1-FINAL — §16.0 taxonomie (schémas = Services Techniques Transverses supports)
 */

const rxV1 = require('./rx-v1.schema');
const merchantPreview = require('./merchant_preview.schema');
const orderTracking = require('./order_tracking');

module.exports = {
  // Wrapper rx.v1
  RxV1WrapperSchema: rxV1.RxV1WrapperSchema,
  PrioritySchema: rxV1.PrioritySchema,
  LayoutSchema: rxV1.LayoutSchema,
  ActionSchema: rxV1.ActionSchema,
  MetaSchema: rxV1.MetaSchema,
  safeParseRxV1: rxV1.safeParseRxV1,
  parseRxV1: rxV1.parseRxV1,
  RX_SCHEMA_VERSION: rxV1.RX_SCHEMA_VERSION,

  // Template merchant_preview
  MerchantPreviewPayloadSchema: merchantPreview.MerchantPreviewPayloadSchema,
  MerchantCardSchema: merchantPreview.MerchantCardSchema,
  HeaderSectionSchema: merchantPreview.HeaderSectionSchema,
  MerchantPreviewSectionSchema: merchantPreview.MerchantPreviewSectionSchema,
  safeParseMerchantPreview: merchantPreview.safeParseMerchantPreview,
  parseMerchantPreview: merchantPreview.parseMerchantPreview,
  MERCHANT_PREVIEW_TEMPLATE: merchantPreview.MERCHANT_PREVIEW_TEMPLATE,

  // Template order_tracking (CONTRAT FIGÉ A3 — CONTRACT_order_tracking_v1.md)
  OrderTrackingSchema: orderTracking.OrderTrackingSchema,
  TRACKING_STATES: orderTracking.TRACKING_STATES,

  // Registre à venir (P0.5) — templates disponibles
  AVAILABLE_TEMPLATES: ['merchant_preview', 'address_creation', 'order_tracking', 'raw_text'],
};
